import React from 'react'

export function PAapiReference() {
  return (
    <div style={{position:'relative', overflow: 'hidden',}}>


      <iframe src='https://developers.xsolla.com/store-api/'
        style={{
          width: '100%',
          height: '80vh',
          overflowY: 'scroll',
          border: 0,
          marginTop: -140,
          backgroundColor: 'white',
          border: '1px solid #c5d0db',
        }}
      >
      </iframe>

    </div>
  )
}
